import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';
import { opportunityChartTooltipChrome } from '../../helpers/opportunityChartTooltipChrome';

export const styleSheet = StyleSheet.create({
	container: {
		background: THEME.colors.background.light,
		borderRadius: THEME.common.borderRadius,
		padding: THEME.spacing.lg,
		boxShadow: `0 1px 3px ${THEME.colors.border.main}`,
		boxSizing: 'border-box',
		gridColumn: 'span 6',
		minWidth: 0,
		width: '100%',
	},
	title: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		marginBottom: THEME.spacing.md,
		color: THEME.colors.text.main,
	},
	loading: {
		padding: THEME.spacing.xl,
		textAlign: 'center',
		color: THEME.colors.text.light,
	},
	empty: {
		padding: THEME.spacing.xl,
		textAlign: 'center',
		color: THEME.colors.text.light,
	},
	tooltip: {
		...opportunityChartTooltipChrome,
	},
	tooltipLabel: {
		fontWeight: THEME.typography.fontWeights.bold,
		marginBottom: THEME.spacing.xs,
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	tooltipValue: {
		margin: 0,
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
});
